import React from 'react';
import { Box } from '@mui/material';
import { FetchCurrentUserQuery } from '../../generated/hooks';
import LeagueList from './LeagueList';
import WelcomePanel from './WelcomePanel';

type HomeProps = {
  currentUser: FetchCurrentUserQuery['currentUser'];
};

function Home({ currentUser }: HomeProps) {
  return (
    <Box sx={{ pt: 2, pb: 4 }}>
      <WelcomePanel currentUser={currentUser} />
      <LeagueList currentUser={currentUser} />
    </Box>
  );
}

export default Home;
